module.exports = __webpack_public_path__ + "img/p5.8be47dca.png";